import React from 'react';
import { Box } from '@qga/roo-ui/components';

import ToggleContent from '@shared/v2/components/ToggleContent';

import { SALES_HOURS } from '@/components/ContactUs/ContactUs';
import Divider from '@/components/Divider';
import LinkButton from '@/components/LinkButton';
import RequestCallbackModal from '@/components/RequestCallbackModal';
import { useDisableWebChat, useWebChat } from '@/components/WebChat';
import CallUs from '../CallUs';
import Items from '../Items';
import call from './assets/call.svg';
import callback from './assets/callback.svg';
import chat from './assets/chat.svg';

const Sales = React.memo(() => {
  const webChat = useWebChat();
  useDisableWebChat();

  return (
    <Box>
      <Box mb="4" fontSize="xl">
        Qantas Holidays Sales
      </Box>
      <Divider mb="10" />
      <Box mb="4" fontSize="lg">
        Operating hours
      </Box>
      <Box>
        <Box>
          Get in touch with our travel specialists to book your holiday over the
          phone or get travel recommendations. Our sales team is available from:
        </Box>
        <Box fontWeight="bold">{` ${SALES_HOURS}.`}</Box>
      </Box>
      <Items
        items={[
          {
            key: 'CALL_US',
            icon: call,
            title: 'Call us',
            titleId: 'sales-call-us',
            description: `
          Speak with our travel specialists to make a booking over the 
          phone or chat about your holiday options. No booking fees.
          `,
            label: 'Sales',
            cta: <CallUs />,
          },
          {
            key: 'REQUEST_CALLBACK',
            icon: callback,
            title: 'Request callback',
            titleId: 'sales-request-callback',
            description: `
          Avoid waiting on hold and have one of our travel 
          specialists call you back at a time that’s most convenient for you.
          `,
            label: 'Sales call back',
            cta: (
              <ToggleContent
                toggle={(open) => (
                  <LinkButton onClick={open}>Request a callback</LinkButton>
                )}
                content={(close) => <RequestCallbackModal onClose={close} />}
              />
            ),
          },
          webChat?.enabled
            ? {
                key: 'LIVE_CHAT',
                icon: chat,
                title: 'Live chat',
                description: `
          Get in touch with our sales team via online chat.
          `,
                label: 'Holidays Sales Chat Support',
                cta: (
                  <LinkButton onClick={() => webChat.open()}>
                    Chat online now
                  </LinkButton>
                ),
              }
            : {},
        ]}
      />
    </Box>
  );
});

export default Sales;
